export default function (direction, field) {
  return {
    direction: direction || "asc",
    field: field|| "",
  }
}
